module.exports = __webpack_public_path__ + "product-pure-powder-capsule-04.jpg?35aa305e2cc566f98bfca9552597c145";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-04.jpg
// module id = 86
// module chunks = 0